import 'firebase/database';
import 'firebase/auth';
import 'firebase/storage';
import firebase from 'firebase/app';
import uuidv4 from 'uuid/v4';


// GET CONTRACTS
export const GET_ALL_EQUIPMENT_PENDING = 'GET_ALL_EQUIPMENT_PENDING';
export const GET_ALL_EQUIPMENT_FULFILLED = 'GET_ALL_EQUIPMENT_FULFILLED';
export const GET_ALL_EQUIPMENT_REJECTED = 'GET_ALL_EQUIPMENT_REJECTED';

export const GET_EQUIPMENT_PENDING = 'GET_EQUIPMENT_PENDING';
export const GET_EQUIPMENT_FULFILLED = 'GET_EQUIPMENT_FULFILLED';
export const GET_EQUIPMENT_REJECTED = 'GET_EQUIPMENT_REJECTED';

export const GET_EQUIPMENT_ITEM_PENDING = 'GET_EQUIPMENT_ITEM_PENDING';
export const GET_EQUIPMENT_ITEM_FULFILLED = 'GET_EQUIPMENT_ITEM_FULFILLED';
export const GET_EQUIPMENT_ITEM_REJECTED = 'GET_EQUIPMENT_ITEM_REJECTED';

export const DELETE_EQUIPMENT_PENDING = 'DELETE_EQUIPMENT_PENDING';
export const DELETE_EQUIPMENT_FULFILLED = 'DELETE_EQUIPMENT_FULFILLED';
export const DELETE_EQUIPMENT_REJECTED = 'DELETE_EQUIPMENT_REJECTED';

export const UPLOAD_EQUIPMENT_PENDING = 'UPLOAD_EQUIPMENT_PENDING';
export const UPLOAD_EQUIPMENT_FULFILLED = 'UPLOAD_EQUIPMENT_FULFILLED';
export const UPLOAD_EQUIPMENT_REJECTED = 'UPLOAD_EQUIPMENT_REJECTED';

export const REMOVE_SEGMENT_FROM_EQUIPMENT_PENDING = 'REMOVE_SEGMENT_FROM_EQUIPMENT_PENDING';
export const REMOVE_SEGMENT_FROM_EQUIPMENT_FULFILLED = 'REMOVE_SEGMENT_FROM_EQUIPMENT_FULFILLED';
export const REMOVE_SEGMENT_FROM_EQUIPMENT_REJECTED = 'REMOVE_SEGMENT_FROM_EQUIPMENT_REJECTED';

export const ADD_SEGMENT_TO_EQUIPMENT_PENDING = 'ADD_SEGMENT_TO_EQUIPMENT_PENDING';
export const ADD_SEGMENT_TO_EQUIPMENT_FULFILLED = 'ADD_SEGMENT_TO_EQUIPMENT_FULFILLED';
export const ADD_SEGMENT_TO_EQUIPMENT_REJECTED = 'ADD_SEGMENT_TO_EQUIPMENT_REJECTED';

export const ADD_TYPE_TO_EQUIPMENT_PENDING = 'ADD_TYPE_TO_EQUIPMENT_PENDING';
export const ADD_TYPE_TO_EQUIPMENT_FULFILLED = 'ADD_TYPE_TO_EQUIPMENT_FULFILLED';
export const ADD_TYPE_TO_EQUIPMENT_REJECTED = 'ADD_TYPE_TO_EQUIPMENT_REJECTED';

export const REMOVE_TYPE_FROM_EQUIPMENT_PENDING = 'REMOVE_TYPE_FROM_EQUIPMENT_PENDING';
export const REMOVE_TYPE_FROM_EQUIPMENT_FULFILLED = 'REMOVE_TYPE_FROM_EQUIPMENT_FULFILLED';
export const REMOVE_TYPE_FROM_EQUIPMENT_REJECTED = 'REMOVE_TYPE_FROM_EQUIPMENT_REJECTED';

export const UPDATE_EQUIPMENT_ITEM_PENDING = 'UPDATE_EQUIPMENT_ITEM_PENDING';
export const UPDATE_EQUIPMENT_ITEM_FULFILLED = 'UPDATE_EQUIPMENT_ITEM_FULFILLED';
export const UPDATE_EQUIPMENT_ITEM_REJECTED = 'UPDATE_EQUIPMENT_ITEM_REJECTED';


//EQUIPMENT RETRIEVAL

const getAllEquipment = () => (dispatch) => {
    dispatch({
        type: GET_ALL_EQUIPMENT_PENDING
    }); 

    firebase.database().ref('/equipment/').child(localStorage.getItem('companyID')).once('value').then(snapshot => {
        const equipment = snapshot.val();

        var equipmentWithIds = [];
        if (equipment != null) {
            equipmentWithIds = Object.keys(equipment).map((equipmentId) => { 
                let equipmentItem = equipment[equipmentId];
                equipmentItem['id'] = equipmentId;
                return equipmentItem;
            });
        }
        dispatch({
            type: GET_ALL_EQUIPMENT_FULFILLED,
            payload: equipmentWithIds
        });
    });
};

const getEquipment = (equipmentIds) => (dispatch) => {
    dispatch({
        type: GET_EQUIPMENT_PENDING
    });
    
    let equipmentForSegment = [];
    let retrievedCount = 0;
    if (equipmentIds == undefined || equipmentIds == null || equipmentIds.lenght == 0) {
        dispatch({
            type: GET_EQUIPMENT_FULFILLED,
            payload: equipmentForSegment
        });
    } else {
        equipmentIds.forEach(function(equipmentID) {
            firebase.database().ref('/equipment/' + localStorage.getItem('companyID') +'/' + equipmentID).once('value').then(snapshot => {
                const equipment = snapshot.val();
                equipment.id = equipmentID;
                equipmentForSegment.push(equipment);
                retrievedCount++;
                if(retrievedCount == equipmentIds.length) {
                    dispatch({
                        type: GET_EQUIPMENT_FULFILLED,
                        payload: equipmentForSegment
                    });
                }
            });
        });
    }
};

const getEquipmentItem = (equipmentID) => (dispatch) => {
    dispatch({
        type: GET_EQUIPMENT_ITEM_PENDING
    }); 

    firebase.database().ref('/equipment/' + localStorage.getItem('companyID') +'/' + equipmentID).once('value').then(snapshot => {
        let equipmentItem = snapshot.val();
        equipmentItem.id = equipmentID;

        dispatch({
            type: GET_EQUIPMENT_ITEM_FULFILLED,
            payload: equipmentItem
        });
    });

};

//EQUIPMENT UDPATING

const updateEquipmentItem = (equipmentitem) => (dispatch) => {
    dispatch({
        type: UPDATE_EQUIPMENT_ITEM_PENDING
    }); 

    let equipmentID = equipmentitem.id;
    let strippedEquipment = JSON.parse(JSON.stringify(equipmentitem));
    delete strippedEquipment.id;
    firebase.database().ref('equipment').child(localStorage.getItem('companyID')).child(equipmentID).set(equipmentitem);

    dispatch({
        type: UPDATE_EQUIPMENT_ITEM_FULFILLED,
        payload: equipmentitem
    }); 

};

//EQUIPMENT DELETION

const deleteEquipment = (equipment) =>  (dispatch) => {
    dispatch({
        type: DELETE_EQUIPMENT_PENDING
    });

    firebase.database().ref('equipment').child(localStorage.getItem('companyID')).child(equipment.id).set(null);

    firebase.database().ref('segments').child(localStorage.getItem('companyID')).once('value', snapshot => {
        
        let segments = snapshot.val();
        var updates = {};
        
        if (segments != undefined){
            var segmentKeys = Object.keys(segments);
            for (const key of segmentKeys) {
                updates['/segments/' + localStorage.getItem('companyID') + '/' + key + '/equipment/' + equipment.id] = null;
            }
            firebase.database().ref().update(updates);
        }
    });

    var ref = firebase.database().ref('planograms').child(localStorage.getItem('companyID'));
    ref.orderByChild('equipmentID').equalTo(equipment.id).once('value', snapshot => {
        const updates = {};
        snapshot.forEach(child => updates[child.key] = null);
        ref.update(updates);
    });

    deleteEquipmentFiles(equipment).then(() => {
        dispatch({
            type: DELETE_EQUIPMENT_FULFILLED
        });
    }).catch(() => {
        dispatch({
            type: DELETE_EQUIPMENT_REJECTED
        });
    });
};

const deleteEquipmentFiles = (equipment) => {
    return new Promise((resolve, reject) => {
        let filesToDelete = [];

        filesToDelete.push({
            path: 'models',
            file: equipment.model 
        });
    
        filesToDelete.push(...getSkinFiles(equipment.skins));
        filesToDelete.push(...getAccessoryFiles(equipment.accessories));

        let fileCount = 0;
    
        for (let file of filesToDelete) {
            deleteFile(file).then((successful) => {
                if (successful) {
                    fileCount ++;
                    if (fileCount == filesToDelete.length) {
                        resolve();
                    }
                } else {
                    reject();
                }
            }).catch((file) => {
                console.log(file);
                fileCount++;
            });
        }
    });
};

const deleteFile = (file) => {
    return new Promise((resolve, reject) => {
        firebase.storage().ref().child('/' + file.path + '/' + file.file).delete().then(function() {
            resolve(true);
        }).catch((error) => {
            console.log(error);
            reject(file);
        });
    });
};

//EQUIPMENT UPLOAD

const uploadEquipment = (metaData, files) => (dispatch) => {
    dispatch({
        type: UPLOAD_EQUIPMENT_PENDING
    });
    console.log(metaData, files);

    uploadFiles(metaData, files).then(() => {
        var newPostKey = firebase.database().ref().child('equipment').child(localStorage.getItem('companyID')).push().key;
        var updates = {};
        
        updates['/equipment/' + localStorage.getItem('companyID') + '/' + newPostKey] = metaData;
        firebase.database().ref().update(updates);
        dispatch({
            type: UPLOAD_EQUIPMENT_FULFILLED
        });
    }).catch((error) => {
        dispatch({
            type: UPLOAD_EQUIPMENT_REJECTED,
            payload: error
        });
    });
};

const uploadFiles = (metadata, files) => {
    return new Promise((resolve, reject) => {
        console.log(metadata, files);
        let filesToUpload = [];

        let uniqueName = uuidv4() + metadata.model;
        filesToUpload.push({
            path: 'models',
            filename: uniqueName,
            file: getFileForFilename(metadata.model, files) 
        });
        metadata.model = uniqueName;

        let previewImageName =  uuidv4() + metadata['preview-image'];
        filesToUpload.push({
            path: 'preview-images',
            filename: previewImageName,
            file: getFileForFilename(metadata['preview-image'], files) 
        });
        metadata['preview-image'] = previewImageName;
    
        console.log('giving it a go');
        let requiresOriginalFileName =  metadata.model.indexOf('.scn') !== -1;
        console.log(requiresOriginalFileName);

        filesToUpload.push(...getSkinFiles(metadata.skins, files, true));
        filesToUpload.push(...getAccessoryFiles(metadata.accessories, files));

        let fileCount = 0;
    
        for (let file of filesToUpload) {

            uploadFile(file).then((successful) => {
                if (successful) {
                    fileCount ++;
                    if (fileCount == filesToUpload.length) {
                        resolve();
                    }
                } else {
                    reject();
                }
            });

        }
    });
};

const getSkinFiles = (skinData, files, requiresOriginalFileName) => {
    
    var skinFiles = [];
    if(skinData != undefined && skinData != null) {
        for (let skin of skinData) {
            let newName = uuidv4() + skin.previewImage;
            skinFiles.push({
                path: 'preview-images',
                filename: newName,
                file: files != null ? getFileForFilename(skin.previewImage, files) : skin.previewImage
            });
            skin.previewImage = newName;
    
            for(let node of skin.nodes) {
                for(let material of node.materials) {
                    for(let property of material.properties) {
                        if (property.image != undefined) {
                            let newPreviewName = requiresOriginalFileName ? property.image : uuidv4() + property.image;
                            skinFiles.push({
                                path: 'wraps',
                                filename: newPreviewName,
                                file: files != null ? getFileForFilename(property.image, files) : property.image
                            });
                            property.image = newPreviewName;
                        }
                    }
                }
            }
        }
    }
    return skinFiles;
};

const getAccessoryFiles = (accesoryData, files) => {
    var accesoryFiles = [];
    if (accesoryData != null && accesoryData != undefined) {
        for (let accesory of accesoryData) {
            let newName =  uuidv4() + accesory.previewImage;
            accesoryFiles.push({
                path: 'preview-images',
                filename: newName,
                file: files != null ? getFileForFilename(accesory.previewImage, files) : accesory.previewImage
            });
            accesory.previewImage = newName;
        }
    }
    
    return accesoryFiles;
};

const getFileForFilename = (filename, files) => {
    return files.filter(file => file.name === filename)[0];
};

const uploadFile = (file) => {
    return new Promise((resolve, reject) => {
        firebase.storage().ref().child('/' + file.path + '/' + file.filename).put(file.file).then(function() {
            resolve(true);
        }).catch(() => {
            reject(false);
        });
    });
};

//SEGMENTS
const removeSegmentFromEquipment = (segmentId, equipmentId) => (dispatch) => {

    dispatch({
        type: REMOVE_SEGMENT_FROM_EQUIPMENT_PENDING
    }); 
 
    firebase.database().ref('equipment').child(localStorage.getItem('companyID')).child(equipmentId).child('segments').child(segmentId).set(null);

    dispatch({
        type: REMOVE_SEGMENT_FROM_EQUIPMENT_FULFILLED,
        payload: {
            equipmentId: equipmentId,
            segmentId: segmentId
        }
    }); 
};

const addSegmentToEquipment = (segmentIds, equipmentIds) => dispatch => {
    dispatch({
        type: ADD_SEGMENT_TO_EQUIPMENT_PENDING
    }); 
    
    for(let segmentID of segmentIds){
        for(let itemID of equipmentIds) {
            firebase.database().ref('equipment/' + localStorage.getItem('companyID') + '/' + itemID + '/segments/' + segmentID).set(true);
        }
    }

    dispatch({
        type: ADD_SEGMENT_TO_EQUIPMENT_FULFILLED,
        payload: {equipmentIds: equipmentIds, segmentIds: segmentIds}
    }); 
};

//PRODUCT TYPES

const addProductTypeToEquipment = (typeIDs, equipmentID) => dispatch => {
    dispatch({
        type: ADD_TYPE_TO_EQUIPMENT_PENDING
    }); 
    
    for(let typeID of typeIDs) {
        firebase.database().ref('equipment/' + localStorage.getItem('companyID') + '/' + equipmentID + '/productTypes/' + typeID).set(true);
    }

    dispatch({
        type: ADD_TYPE_TO_EQUIPMENT_FULFILLED,
        payload: {
            typeIDs: typeIDs,
            equipmentID: equipmentID
        }
    }); 
};

const removeProductTypeFromEquipment = (typeID, equipmentId) => (dispatch) => {

    dispatch({
        type: REMOVE_TYPE_FROM_EQUIPMENT_PENDING
    }); 
 
    firebase.database().ref('equipment').child(localStorage.getItem('companyID')).child(equipmentId).child('productTypes').child(typeID).set(null);

    dispatch({
        type: REMOVE_TYPE_FROM_EQUIPMENT_FULFILLED,
        payload: {
            typeID: typeID
        }
    }); 
};

export { getAllEquipment, getEquipmentItem, getEquipment, deleteEquipment, uploadEquipment, removeSegmentFromEquipment, addSegmentToEquipment, addProductTypeToEquipment, removeProductTypeFromEquipment, updateEquipmentItem};


// WEBPACK FOOTER //
// ./src/components/state/actions/EquipmentActions.js